import { Route, Routes, useLocation } from 'react-router';
import SuperAdminLayout from '@/components/layouts/SuperAdminLayout';
import QueueDashboardPage from '@/pages/superAdmin/QueueDashboard';
import Users from '@/pages/Users';
import NotFound from '../components/blocks/NotFound';
import CenteredLayout from '../components/layouts/CenteredLayout';
import { useUser } from '../contexts/UserSession';
import InvitationPage from '../pages/Invitation';
import LoginPage from '../pages/LoginPage';
import MSALCallback from '../pages/LoginPage/MSAL/MSALCallback';
import OIDCCallback from '../pages/LoginPage/OIDC/OIDCCallback';
import OrganizationPage from '../pages/Organization';
import ProfilePage from '../pages/ProfilePage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import SignOutPage from '../pages/SignOutPage';
import OrganizationsPage from '../pages/superAdmin/Organizations';
import SystemSettingsPage from '../pages/superAdmin/SystemSettings';
import RedirectTo from '../RedirectTo';

const SuperAdminRoutes = () => {
    const user = useUser();
    const location = useLocation();

    if (!user) {
        return (
            <Routes>
                <Route element={<CenteredLayout />} path="/invitation/*">
                    <Route element={<InvitationPage />} index />
                    <Route element={<NotFound homePath="/invitation/" />} path="*" />
                </Route>
                <Route element={<CenteredLayout />} path="/login/*">
                    <Route element={<LoginPage />} index />
                    <Route element={<ResetPasswordPage />} path="resetPassword" />
                    <Route element={<MSALCallback />} path="sso/msal" />
                    <Route element={<OIDCCallback />} path="sso/oidc" />
                    <Route element={<NotFound homePath="/login/" />} path="*" />
                </Route>
                <Route
                    element={<RedirectTo state={{ from: location.pathname, fromState: location.state }} to="/login/" />}
                    path="*"
                />
            </Routes>
        );
    }

    const redirectTo = (
        <RedirectTo to={location.state?.from || '/'} state={{ ...location.state?.fromState, isAuthenticated: true }} />
    );

    return (
        <Routes>
            <Route element={redirectTo} path="/login/*" />
            <Route element={redirectTo} path="/invitation/*" />
            <Route element={<SuperAdminLayout />} path="*">
                <Route element={<RedirectTo to="/organizations" />} index />
                <Route element={<OrganizationsPage />} path="organizations" />
                <Route element={<OrganizationPage />} path="organizations/:id" />
                <Route element={<Users />} path="users" />
                <Route element={<QueueDashboardPage />} path="queues" />
                <Route element={<SystemSettingsPage />} path="settings" />
                <Route element={<ProfilePage />} path="profile" />
                <Route element={<SignOutPage />} path="signout" />
                <Route element={<NotFound homePath="/" />} path="*" />
            </Route>
        </Routes>
    );
};

export default SuperAdminRoutes;
